import type { SxProps, Theme } from "@mui/material";

/**
 * Shared geometry for the wizard's steps, so the form column and the "three switches" aside land on the
 * same grid on every step instead of each step inventing its own split. The aside drops below the form
 * on narrow screens rather than squeezing the fields.
 */
export const CLIPBOARD_STEP_COLUMNS_SX: SxProps<Theme> = {
	display: "flex",
	flexDirection: { xs: "column", md: "row" },
	alignItems: "flex-start",
	gap: { xs: 2.5, md: 4 },
	width: "100%",
};

/** The step's working column: fields and messages. Capped so a text field never spans the whole modal. */
export const CLIPBOARD_STEP_FORM_COLUMN_SX: SxProps<Theme> = {
	display: "flex",
	flexDirection: "column",
	gap: 2,
	flex: 1,
	minWidth: 0,
	width: "100%",
	maxWidth: { md: 420 },
};
